module.exports = __webpack_public_path__ + "static/media/sidebar-4.53acd20f.jpg";